var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDialogCloseWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 13.9404L10.0473 7.98618L16 2.04145L13.9404 0L7.98982 5.94836L2.04364 0L0 2.04364L5.95345 8.00436L0 13.9564L2.04364 16L8.00945 10.0422L13.9585 16L16 13.9404Z",
    fill: "#255056"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialogCloseWhite);
export default __webpack_public_path__ + "static/media/dialog-close-white.7a613aaaebae53e79fbfce4a2f140c49.svg";
export { ForwardRef as ReactComponent };